import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./window-splitter.script";
export function RuiWindowSplitter({
  primary,
  secondary,
  orientation = "horizontal",
  ...props
}) {
  const horizontal = orientation !== "vertical";
  return /* @__PURE__ */jsx("rui-window-splitter", {
    ...props,
    orientation,
    children: /* @__PURE__ */jsxs("div", {
      class: cx("rui-window-splitter", horizontal ? "rui-window-splitter--horizontal" : "rui-window-splitter--vertical"),
      "data-ref": "root",
      children: [/* @__PURE__ */jsx("div", {
        "data-ref": "primary",
        class: "rui-window-splitter__pane",
        children: primary
      }), /* @__PURE__ */jsx("div", {
        "data-ref": "separator",
        class: "rui-window-splitter__separator",
        role: "separator",
        tabindex: 0
      }), /* @__PURE__ */jsx("div", {
        "data-ref": "secondary",
        class: "rui-window-splitter__pane",
        children: secondary
      })]
    })
  });
}